import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { Button } from 'reactstrap';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import { getRegion, saveRegion, updateRegion, getCountry, deleteRegion } from 'store/actions/location';
import List from './list';
import AddDialog from './addDialog';
import { useHistory } from 'react-router';
import { t } from 'i18next';
import AddNewButton from 'components/ActionButtons/addNewButton';

function Region() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();
  const router = useHistory();
  const regions = useSelector((state) => state.location.regions);
  const countries = useSelector((state) => state.location.countries);

  const headers = ['no', 'name', 'country', 'created_at', 'created_by', ''];
  React.useEffect(() => {
    dispatch(getCountry({}));
    dispatch(getRegion(queryString.parse(router.location.search), true));
  }, [getRegion, getCountry, dispatch, router.location.search]);

  return (
    <>
      <List
        headers={headers}
        data={regions}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        buttons={
          <>
            <AddNewButton
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
              type='region'
            />

            <Button style={{ width: 95 }} size='sm' onClick={() => dispatch(getRegion({}, true))}>
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={editData ? `${t('edit')} ${t('region')}` : `${t('add')} ${t('region')}`}
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        options={{ countries: countries }}
        onSubmit={(values) => {
          setModalOpen(false);
          if (editData) dispatch(updateRegion({ ...values, _id: editData?._id }));
          else dispatch(saveRegion(values));

          setTimeout(() => dispatch(getRegion({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('region')}`}
        body={`Are you sure to delete ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(deleteRegion(editData?._id));
          setTimeout(() => dispatch(getRegion({}, true)), 1000);
        }}
      />
    </>
  );
}

export default Region;
